<template>
  <div id="modalAnalisys" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ textModal }} Análise</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="save">
          <div class="modal-body">
            <div class="row g-3">
              <!-- Campo analisysDate -->
              <div class="col-sm-12">
                <label class="form-label">
                  Data da Análise: <span class="text-danger">*</span>
                </label>
                <input
                  :disabled="this.userDistribution.analisysCreatedAt"
                  type="date"
                  class="form-control"
                  :class="{
                    'is-invalid':
                      v$.userDistribution.analisysDate.$errors.length,
                  }"
                  v-model="userDistribution.analisysDate"
                />
                <span
                  v-if="v$.userDistribution.analisysDate.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <!-- Campo analisysObservation -->
              <div class="col-sm-12">
                <label class="form-label">
                  Observação: <span class="text-danger">*</span>
                </label>
                <textarea
                  :disabled="this.userDistribution.analisysCreatedAt"
                  class="form-control"
                  rows="4"
                  maxlength="250"
                  placeholder="Digite sua observação (máximo 250 caracteres)"
                  :class="{
                    'is-invalid':
                      v$.userDistribution.analisysObservation.$errors.length,
                  }"
                  v-model="userDistribution.analisysObservation"
                />
                <span
                  v-if="
                    v$.userDistribution.analisysObservation.required.$invalid
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>

              <!-- Campo analisysResponsable -->
              <div class="col-sm-12">
                <label class="form-label">
                  Responsável: <span class="text-danger">*</span>
                </label>
                <input
                  :disabled="this.userDistribution.analisysCreatedAt"
                  type="text"
                  class="form-control"
                  maxlength="80"
                  placeholder="Digite o nome do responsável (máximo 80 caracteres)"
                  :class="{
                    'is-invalid':
                      v$.userDistribution.analisysResponsable.$errors.length,
                  }"
                  v-model="userDistribution.analisysResponsable"
                />
                <span
                  v-if="
                    v$.userDistribution.analisysResponsable.required.$invalid
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
            </div>
          </div>
          <div class="modal-footer border-top-0">
            <button
              type="button"
              class="btn btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              v-if="this.userDistribution.analisysCreatedAt == null"
              type="submit"
              class="btn btn-primary"
              :title="textModal"
              :disabled="v$.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="ph ph-spinner spinner" />
              </span>
              <span v-else>Cadastrar Análise</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { showModal, hideModal } from '@/utils/modal'

export default {
  name: 'CreateEditBoardModal',

  props: {
    distributionId: {
      type: String,
      default: null,
    },
    uuid: {
      type: String,
      default: null,
    },
  },

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      userDistribution: {
        uuid: this.uuid,
        distributionId: this.distributionId,
        analisysCreatedAt: null,
        analisysCreatedBy: null,
        analisysDate: null,
        analisysObservation: null,
        analisysResponsable: null,
      },
      disableButton: false,
    }
  },

  computed: {
    textModal() {
      return this.userDistribution.analisysCreatedAt
        ? 'Informações da '
        : 'Cadastrar'
    },
  },

  methods: {
    async getUserDistribution() {
      try {
        this.userDistribution = await this.$store.dispatch(
          'getUserDistribution',
          {
            uuid: this.uuid,
            id: this.distributionId,
          },
        )
        showModal('modalAnalisys')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async save() {
      if (!this.v$.$invalid) {
        this.disableButton = true
        try {
          let response = null

          response = await this.$store.dispatch('createAnalisys', {
            id: this.distributionId,
            uuid: this.uuid,
            userDistribution: this.userDistribution,
          })

          hideModal()
          this.$emit('closeModal', true)
          this.$root.$refs.notification.success(response.message)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },
  },

  validations() {
    return {
      userDistribution: {
        analisysDate: { required },
        analisysObservation: { required },
        analisysResponsable: { required },
      },
    }
  },

  mounted() {
    this.getUserDistribution()
  },
}
</script>
